export default {
  colors: {
    background: '#F2F3F5',
    backgroundInverted: '#202225',
    card: '#FFFFFF',
    cardInverted: '#2F3136',
    text: '#060606',
    textFaint: '#7f848a',
    textFaintInverted: '#B0B2B6',
    textLight: '#FFFFFF',
    textDark: '#060606',
    textInverted: '#FFFFFF',
    green: '#43B581',
    red: '#F04747',
    linkColor: '#1e96fc',
  },
  borderRadius: '0.5rem',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
}